module.exports = __webpack_public_path__ + "static/demo-e9ebef3e3e63e22ea85ea42a75f7577b.gif";